import React from 'react';

const BybitPreview = ({ data }) => {
    const currency = data.currency || 'USDT';
    const amount = data.amount || '0';
    const chainType = data.chainType || 'TRC20';
    const walletAddress = data.walletAddress || 'TWqSdf...RHCL2u';
    const fallbackEmail = data.fallbackEmail || 'support@bybit.com';
    const timestamp = new Date().toISOString().replace('T', ' ').substring(0, 19) + '(UTC)';

    return (
        <div className="bybit-preview">
            <div className="bybit-header">
                <img
                    className="bybit-logo-img"
                    src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/f354a305-ccb3-4b43-bb5c-39b08c0ac9707a1f37228082bb6ce81088e3980e6213.png"
                    alt="Bybit"
                    width="221"
                />
            </div>
            <div className="bybit-body">
                <p>Dear valued Bybit trader,</p>
                <p>Your deposit has been confirmed.</p>
                <p>Deposit amount: {amount} {currency}</p>
                <p>Chain type: {chainType}</p>
                <p>Deposit address: {walletAddress}</p>
                <p>Timestamp: {timestamp}</p>
                <p>
                    If you believe your account has been compromised, please contact us
                    immediately via live chat or{' '}
                    <a href={`mailto:${fallbackEmail}`} className="bybit-link">support email</a>{' '}
                    using your registered email address.
                </p>
                <p>
                    To enhance your account security, consider enabling Google
                    Two-Factor Authentication (2FA) and setting up a Fund Password
                    from theAccount &amp; Security page.
                </p>
                <p>Regards,</p>
                <p>The Bybit Team</p>
            </div>
            <div className="bybit-footer">
                <img
                    className="bybit-footer-logo"
                    src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/6a63e23a-b9b0-4637-8221-4d94b530acea3836c84f172151f52d2d6410443e3768.png"
                    alt="Bybit"
                    width="95"
                />
                <p className="bybit-footer-updates">
                    Never miss a beat on our latest product updates and events.
                </p>
                <div className="bybit-social-row">
                    <img className="bybit-social-icon" src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/966e7680-8f83-492b-b02f-a0360dea2c5f1eaba4ae14c4e9b5a88d2df88eb00aeb.png" alt="Twitter" width="40" />
                    <img className="bybit-social-icon" src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/873a047d-4d6c-41fa-b42c-a71aa1afc703b262cc27ee8ddcaa8704b6725755b4a7.png" alt="Instagram" width="40" />
                    <img className="bybit-social-icon" src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/9338e802-8753-4cab-ba90-020942731d57d541e47624222f95a15135f5ec2dde01.png" alt="TikTok" width="40" />
                    <img className="bybit-social-icon" src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/97fb4364-df15-4b61-8f18-685d002eb7ed06944bef98b56ea368fa34b9ef456e90.png" alt="YouTube" width="40" />
                    <img className="bybit-social-icon" src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/602922a7-31ab-4a90-84e9-aa375b154cf6ac1d1a7ed1fb224e6d9abe55aea6f3d5.png" alt="Facebook" width="40" />
                    <img className="bybit-social-icon" src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/3f19498d-8d85-421d-856c-9541c7b506e6b7134be5734d1368439928f9ceb40503.png" alt="Telegram" width="40" />
                </div>
                <p className="bybit-footer-text">Trade on the go with Bybit</p>
                <div className="bybit-app-row">
                    <img className="bybit-app-badge" src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/c4a80c80-9f85-4efa-96d1-991fe69e9001b04ba90a0ec2841cdeb1ae9741ffd98a.png" alt="App Store" width="142" />
                    <img className="bybit-app-badge" src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/494cdd37-a457-4514-93f9-1d9020cabddecdd67f1e6a0ff92a160c9d46514a350b.png" alt="Google Play" width="164" />
                </div>
                <div className="bybit-footer-links">
                    <span className="bybit-footer-link">Latest Promotions</span>
                    <span className="bybit-footer-link">Help Center</span>
                </div>
                <p className="bybit-copyright">
                    Copyright @2018 - 2025 Bybit. All rights reserved.
                </p>
            </div>
        </div>
    );
};

export default BybitPreview;